import React from 'react';
import { view } from 'react-easy-state';
import Fade from 'react-reveal/Fade';
import { withTranslation } from 'react-i18next';

const PrestSceltaStruttura = ({ onClick, t }) => {
  return (
    <Fade bottom duration={300}>
      <div className="kfpr-content kfpr-content-sceglistrutt">
          <div className="kfpr-row kfpr-row-txt kfpr-row-txt-big">
              <p>{t("Scegli in quale struttura preferisci effettuare la prestazione")}:</p>
              <div className="kfpr-row kfpr-row-btn">
                <button className="button small" value={"Policlinico Gemelli"} onClick={onClick}>Policlinico Gemelli</button>
                <button className="button small" value={"Presidio Columbus"} onClick={onClick}>Presidio Columbus</button>
              </div>
          </div>
      </div>
    </Fade>
  )
}

export default withTranslation()(view(PrestSceltaStruttura));
